import React, { useMemo } from 'react';
import SearchableCombobox from '../common/SearchableCombobox';

const SearchableOrganizationSelect = ({
  options,
  value,
  onChange,
  placeholder = 'Select school',
  emptyStateText = 'No schools available to attach',
  noResultsText = 'No matching schools',
}) => {
  const normalizedOptions = useMemo(
    () => options.map((option) => ({ label: option.name, value: String(option.id) })),
    [options]
  );

  return (
    <SearchableCombobox
      options={normalizedOptions}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      emptyStateText={emptyStateText}
      noResultsText={noResultsText}
    />
  );
};

export default SearchableOrganizationSelect;
